import { render, staticRenderFns } from "./CoreMenuOption.vue?vue&type=template&id=230e259a&scoped=true"
import script from "./CoreMenuOption.vue?vue&type=script&lang=js"
export * from "./CoreMenuOption.vue?vue&type=script&lang=js"
import style0 from "./CoreMenuOption.vue?vue&type=style&index=0&id=230e259a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.6__css-loader@7.1.2_webpa_d27aba7c9c0d786a810fc7f5935a809d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230e259a",
  null
  
)

export default component.exports